import { useQuery } from "@tanstack/react-query";
import { getForm } from "../services/get-form";
import { FormDetails } from "@/pages/forms/types/form";

export function useFormDetails(id?: string) {
  return useQuery<FormDetails>({
    queryKey: ["form", id],
    queryFn: () => getForm(id as string),
    enabled: Boolean(id),
    refetchOnWindowFocus: false,
  });
}
